import { loadQuery } from 'react-relay';
import { accountQuery } from 'services/account/__generated__/accountQuery.graphql';
import { ACCOUNT_QUERY } from 'services/account/account.relay.services';
import { PAYMENT_OUTS_PAGINATION_QUERY } from 'services/payment/payment.relay.services';
import { paymentOutsPaginationQuery } from 'services/payment/__generated__/paymentOutsPaginationQuery.graphql';
import { getAccountId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';

export const PaymentsPreloadData = () => {
  const accountId = getAccountId() ?? '';

  return {
    paymentsOutQueryRef: loadQuery<paymentOutsPaginationQuery>(
      RelayEnvironment,
      PAYMENT_OUTS_PAGINATION_QUERY,
      {
        first: 1000,
        ordering: [
          { sort: 'ID', direction: 'ASC' },
          { sort: 'CREATED_AT', direction: 'DESC' },
        ],
        filter: {
          where: {
            accountId: {
              equalTo: accountId,
            },
            deletedAt: {
              notEqualTo: null,
            },
          },
        },
      },
      { fetchPolicy: 'store-or-network' },
    ),
    accountQueryRef: loadQuery<accountQuery>(
      RelayEnvironment,
      ACCOUNT_QUERY,
      {
        id: accountId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type PaymentsPreloadDataType = ReturnType<typeof PaymentsPreloadData>;
